module.exports = __webpack_public_path__ + "static/media/cabot-juan.b4ff28f7.jpg";